import { BaseFilter } from 'src/app/shared/services/base.filter';

export class TransactionTypeFilter extends BaseFilter {

}
